<template>
    <div class="Details">
        <slot></slot>
        <p v-show="copyShow">
            全文链接:请复制到手机浏览器或电脑浏览器打开
            <span style="display:block;width:100%;text-align:center;">
                <a
                    href="javascript:;"
                    style="margin:0 20px 0 0"
                    class="pdfDiv"
                    size="small"
                    plain
                    type="primary"
                    :data-clipboard-text="pdfLink"
                    @click="copy()"
                >
                    <img src="../assets/copy.png" alt="" />
                </a>
                &lArr; 点击复制
            </span>
        </p>    
        <van-button color="#0d60a2" @click="downloadPdf()" v-show="pdfShow"> <img src="../publics/image/ck.png" alt="" /> 查看pdf </van-button>
        <!-- <van-button color="#0d60a2" @click="downloadPdf()" v-show="fullShow"> <img src="../publics/image/ck.png" alt="" /> 查看全文 </van-button> -->
    </div>
</template>
<script>
import api from "@/request/api";
import { Toast, Dialog } from "vant";
import Clipboard from "clipboard";
import wx from "weixin-js-sdk";

export default {
    data() {
        return {
            copyShow: false, // 复制
            pdfShow: false, // pdf
            fullShow: false, // 全文
            type: "", // cnki chkd wf wp...
            downloadData: "", // 查看pdf 参数
            pdfLink: "" // pdf 链接
        };
    },
    mounted() {
        if (sessionStorage.getItem("copyType") == 1) {
            this.copyShow = true;
            this.pdfLink = sessionStorage.getItem("pdfLink");
        }
    },
    methods: {
        downloadPdf() {
            if (this.pdfLink != "" && this.pdfLink != "null") {
                if (window.__wxjs_environment === "miniprogram") {
                    if (this.pdfLink != "" && this.pdfLink != null && this.pdfLink != undefined) {
                        wx.miniProgram.navigateTo({
                            url: "../a/a?pdfUrl=" + this.pdfLink
                        });
                    }
                    this.link = false;
                } else {
                    sessionStorage.setItem("copyType", 1);
                    window.location.href = this.pdfLink;
                }
            } else {
                api.download(this.type, this.downloadData).then((res) => {
                    if (res.code == 0) {
                        if (new Date().getTime() - localStorage.getItem("time") >= 30 * 24 * 60 * 60 * 1000) {
                            Dialog.confirm({
                                message: "将要打开pdf，您可以在预览后返回此界面复制链接进行分享或者在浏览器进行下载",
                                confirmButtonText: "我知道了",
                                cancelButtonText: "不再提示"
                            })
                                .then(() => {
                                    this.dofun(res);
                                })
                                .catch(() => {
                                    // 不再提示
                                    this.dofun(res);
                                    localStorage.setItem("time", new Date().getTime());
                                });
                        } else {
                            this.dofun(res);
                        }
                    } else if (res.code == 11) {
                        this.$parent.refresh();
                    } else if (res.code == 3) {
                        Toast(res.msg);
                    }
                });
            }
        },
        dofun(res) {
            this.pdfLink = res.data;
            this.copyShow = true;
            var isWX = window.__wxjs_environment === "miniprogram";
            if (isWX) {
                wx.miniProgram.navigateTo({
                    url: "../a/a?pdfUrl=" + res.data
                });
                // this.copyShow = false;
            } else {
                sessionStorage.setItem("copyType", 1);
                sessionStorage.setItem("pdfLink", this.pdfLink);
                window.location.href = res.data;
            }
        },
        copy() {
            let clipboard = new Clipboard(".pdfDiv");
            clipboard.on("success", () => {
                Toast("复制成功");
                clipboard.destroy();
            });
            clipboard.on("error", () => {
                Toast("复制失败");
                clipboard.destroy();
            });
        }
    }
};
</script>
<style lang="less">
.Details {
    margin-top: 0.8rem;
    background: #fff;
    padding: 1rem;

    h2 {
        color: #393939;
        margin-bottom: 0.8rem;
    }

    > p {
        color: #353535;
        padding-bottom: 1rem;
        // border-bottom: 1px solid #f3f3f3;
        //   margin-top: 0.5rem;
        line-height: 1.5rem;

        a {
            img {
                width: 30px;
                vertical-align: middle;
            }
        }

        span {
            width: 20%;
            display: inline-block;
        }
    }

    div {
        p {
            margin-top: 0.5rem;
            line-height: 1.5rem;

            a {
                img {
                    width: 30px;
                    vertical-align: middle;
                }
            }

            span {
                // width: 30%;
                display: inline-block;
            }
        }
    }

    .van-button {
        width: 100%;
        font-size: 0.8rem;
        margin: 0.5rem 0 1rem;
        // background-color: #007c9d !important;
        // border-color: #007c9d !important;

        img {
            width: 1rem;
            vertical-align: -0.1rem;
            margin-right: 0.2rem;
        }
    }
}
</style>
